import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { store } from 'store';

import { raaMuiTheme } from 'raa-react';

import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';

import { ThemeProvider } from '@mui/material';

import App from 'App';
import { DialogProvider } from 'context/dialogContext';
import { DrawerMobileTemplateContextProvider } from 'context/drawerMobileTemplateContext';
import { MapInteractionContextProvider } from 'context/mapInteractionContext';
import { BlockerProvider } from 'context/navigationBlockContext';
import 'index.scss';
import reportWebVitals from 'reportWebVitals';
import { baseHref } from 'utilities/getBaseHref';

const rootElement = document.getElementById('root');

const root = createRoot(rootElement!);
const router = createBrowserRouter(
  [
    {
      path: '*',
      element: (
        <ErrorBoundary>
          <DrawerMobileTemplateContextProvider>
            <DialogProvider>
              <BlockerProvider>
                <App />
              </BlockerProvider>
            </DialogProvider>
          </DrawerMobileTemplateContextProvider>
        </ErrorBoundary>
      ),
      children: []
    }
  ],
  { basename: baseHref }
);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={raaMuiTheme}>
      <MapInteractionContextProvider>
        <StrictMode>
          <RouterProvider router={router} />
        </StrictMode>
      </MapInteractionContextProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// För att enable:a msw-mock sätts REACT_APP_ENABLE_MOCKS till true i .env.development.
// Se fil handlers.ts i mock-folder för att lägga till ytterligare mocks.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_MOCKS === 'true') {
  import('../mocks/browser').then(({ worker }) => worker.start({ onUnhandledRequest: 'bypass', quiet: true }));
}
